import { Navigate, NavLink, Outlet } from "react-router-dom";
import { useAdminAuth } from "../../context/AdminAuth";
import { LOGO_URL } from "../../data/content";
import {
  BarChart3, ShoppingBag, Cookie, Users, MessageCircle, Vote, LogOut, Loader2, CreditCard, Calendar, Star,
} from "lucide-react";

const navItems = [
  { to: "/admin", label: "Stats", icon: BarChart3, end: true },
  { to: "/admin/orders", label: "Commandes", icon: ShoppingBag },
  { to: "/admin/products", label: "Produits", icon: Cookie },
  { to: "/admin/availability", label: "Créneaux", icon: Calendar },
  { to: "/admin/reviews", label: "Avis", icon: Star },
  { to: "/admin/loyalty", label: "Fidélité", icon: CreditCard },
  { to: "/admin/club", label: "Cloud Club", icon: Users },
  { to: "/admin/contacts", label: "Messages", icon: MessageCircle },
  { to: "/admin/votes", label: "Votes Lab", icon: Vote },
];

export default function AdminLayout() {
  const { admin, checking, logout } = useAdminAuth();

  if (checking) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-amyu-bg">
        <Loader2 className="animate-spin text-coral" size={32} />
      </div>
    );
  }
  if (!admin) return <Navigate to="/admin/login" replace />;

  return (
    <div className="min-h-screen flex flex-col md:flex-row bg-amyu-bg" data-testid="admin-layout">
      <aside className="md:w-64 bg-white border-r border-amyu/30 p-5 md:min-h-screen md:sticky md:top-0 flex md:flex-col gap-3 md:gap-6 overflow-x-auto">
        <a href="/" className="flex items-center gap-2 shrink-0">
          <img src={LOGO_URL} alt="Amyu" className="h-10" />
        </a>
        <nav className="flex md:flex-col gap-1 flex-1">
          {navItems.map((item) => {
            const Icon = item.icon;
            return (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.end}
                data-testid={`admin-nav-${item.label.toLowerCase().replace(/\s/g, "-")}`}
                className={({ isActive }) =>
                  `flex items-center gap-3 px-4 py-2.5 rounded-2xl text-sm font-medium whitespace-nowrap transition-colors ${
                    isActive
                      ? "bg-coral text-white"
                      : "text-amyu-ink hover:bg-amyu-cream"
                  }`
                }
              >
                <Icon size={16} />
                <span>{item.label}</span>
              </NavLink>
            );
          })}
        </nav>
        <div className="hidden md:block text-xs text-amyu-muted border-t border-amyu/30 pt-4">
          <div className="truncate">{admin.email}</div>
          <button
            onClick={logout}
            data-testid="admin-logout-btn"
            className="mt-3 inline-flex items-center gap-2 text-coral hover:underline"
          >
            <LogOut size={14} /> Déconnexion
          </button>
        </div>
        <button
          onClick={logout}
          data-testid="admin-logout-btn-mobile"
          className="md:hidden ml-auto inline-flex items-center gap-1 text-coral text-sm"
        >
          <LogOut size={14} />
        </button>
      </aside>
      <main className="flex-1 p-5 md:p-10 max-w-full overflow-x-hidden">
        <Outlet />
      </main>
    </div>
  );
}
